import { render } from "./Partner.vue?vue&type=template&id=1c69492f&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=1c69492f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c69492f"]])

export default __exports__